var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 44,
    viewBox: "0 0 129 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3319 32.7397V15.0411H59.2774V32.7397H56.3319ZM50.4922 17.2534V14.5205H65.1172V17.2534H50.4922Z",
    fill: "url(#paint0_linear_12_42145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.472 27.4562V24.7493H74.1547V27.4562H65.472Z",
    fill: "url(#paint1_linear_12_42145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7046 32.7397V25.5301C85.7046 24.6973 85.4399 24.0119 84.9106 23.474C84.3983 22.9361 83.7324 22.6671 82.9128 22.6671C82.3664 22.6671 81.8797 22.7886 81.4528 23.0315C81.0259 23.2744 80.693 23.6128 80.4539 24.0466C80.2149 24.4804 80.0953 24.9749 80.0953 25.5301L78.994 24.9055C78.994 23.9511 79.1989 23.1096 79.6087 22.3808C80.0185 21.6347 80.582 21.0534 81.2992 20.637C82.0334 20.2032 82.853 19.9863 83.758 19.9863C84.6801 19.9863 85.4997 20.1945 86.2168 20.611C86.934 21.0274 87.4975 21.6087 87.9073 22.3548C88.3171 23.0836 88.522 23.9338 88.522 24.9055V32.7397H85.7046ZM77.2779 32.7397V14H80.0953V32.7397H77.2779Z",
    fill: "url(#paint2_linear_12_42145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5332 33C95.4234 33 94.4159 32.7137 93.5109 32.1411C92.623 31.5685 91.9144 30.7963 91.385 29.8247C90.8728 28.8356 90.6167 27.7338 90.6167 26.5192C90.6167 25.2872 90.8728 24.1854 91.385 23.2137C91.9144 22.2247 92.623 21.4438 93.5109 20.8712C94.4159 20.2813 95.4234 19.9863 96.5332 19.9863C97.4724 19.9863 98.3005 20.1945 99.0177 20.611C99.7519 21.01 100.332 21.5653 100.759 22.2767C101.186 22.9881 101.4 23.795 101.4 24.6973V28.289C101.4 29.1913 101.186 29.9982 100.759 30.7096C100.35 31.421 99.7776 31.9849 99.0433 32.4014C98.3091 32.8005 97.4724 33 96.5332 33ZM96.9943 30.2931C98.0359 30.2931 98.8726 29.9374 99.5043 29.226C100.153 28.5146 100.478 27.6037 100.478 26.4932C100.478 25.747 100.332 25.0877 100.042 24.5151C99.7519 23.9425 99.3421 23.5 98.8128 23.1877C98.3005 22.858 97.6944 22.6932 96.9943 22.6932C96.3113 22.6932 95.7051 22.858 95.1758 23.1877C94.6635 23.5 94.2537 23.9425 93.9463 24.5151C93.6561 25.0877 93.5109 25.747 93.5109 26.4932C93.5109 27.2393 93.6561 27.8986 93.9463 28.4712C94.2537 29.0438 94.6635 29.495 95.1758 29.8247C95.7051 30.137 96.3113 30.2931 96.9943 30.2931ZM100.298 32.7397V29.3822L100.785 26.337L100.298 23.3178V20.2466H103.116V32.7397H100.298Z",
    fill: "url(#paint3_linear_12_42145)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.264 33C109.581 33 108.923 32.9132 108.292 32.7397C107.66 32.5489 107.079 32.2886 106.55 31.9589C106.021 31.6119 105.56 31.1954 105.167 30.7096L106.96 28.8877C107.387 29.3909 107.873 29.7726 108.42 30.0329C108.983 30.2758 109.615 30.3973 110.315 30.3973C110.947 30.3973 111.425 30.3018 111.749 30.111C112.074 29.9201 112.236 29.6425 112.236 29.2781C112.236 28.8963 112.082 28.6014 111.775 28.3932C111.468 28.1849 111.066 28.0114 110.571 27.8726C110.093 27.7164 109.581 27.5603 109.034 27.4041C108.505 27.2479 107.993 27.0397 107.498 26.7795C107.019 26.5018 106.627 26.1288 106.319 25.6603C106.012 25.1918 105.858 24.5845 105.858 23.8384C105.858 23.0402 106.038 22.3548 106.396 21.7822C106.772 21.2096 107.293 20.7671 107.959 20.4548C108.642 20.1425 109.453 19.9863 110.392 19.9863C111.382 19.9863 112.253 20.1685 113.004 20.5329C113.773 20.8799 114.413 21.4091 114.925 22.1205L113.132 23.9425C112.774 23.4913 112.364 23.153 111.903 22.9274C111.442 22.7018 110.913 22.589 110.315 22.589C109.752 22.589 109.316 22.6758 109.009 22.8493C108.701 23.0228 108.548 23.2744 108.548 23.6041C108.548 23.9511 108.701 24.2201 109.009 24.411C109.316 24.6018 109.709 24.7667 110.187 24.9055C110.682 25.0443 111.194 25.2005 111.724 25.374C112.27 25.5301 112.782 25.7557 113.26 26.0507C113.756 26.3283 114.157 26.71 114.464 27.1959C114.772 27.6644 114.925 28.2804 114.925 29.0438C114.925 30.2584 114.507 31.2215 113.67 31.9329C112.834 32.6443 111.698 33 110.264 33Z",
    fill: "url(#paint4_linear_12_42145)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.675 32.7397V25.5301C125.675 24.6973 125.41 24.0119 124.881 23.474C124.369 22.9361 123.703 22.6671 122.883 22.6671C122.337 22.6671 121.85 22.7886 121.423 23.0315C120.996 23.2744 120.663 23.6128 120.424 24.0466C120.185 24.4804 120.066 24.9749 120.066 25.5301L118.964 24.9055C118.964 23.9511 119.169 23.1096 119.579 22.3808C119.989 21.6347 120.552 21.0534 121.269 20.637C122.004 20.2032 122.823 19.9863 123.728 19.9863C124.65 19.9863 125.47 20.1945 126.187 20.611C126.904 21.0274 127.468 21.6087 127.877 22.3548C128.287 23.0836 128.492 23.9338 128.492 24.9055V32.7397H125.675ZM117.248 32.7397V14H120.066V32.7397H117.248Z",
    fill: "url(#paint5_linear_12_42145)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1324 40.5269L22.1456 41.5401C23.2673 40.4184 26.3068 36.7275 23.9186 31.4446L23.9159 31.4384C21.8995 26.982 18.406 23.5679 16.2836 21.4938C15.9942 21.2043 15.7047 21.2043 15.4152 21.4938L9.19142 27.7175C8.82957 28.0794 8.61246 28.007 8.32299 27.7175L2.46106 21.8556C2.17158 21.5661 2.17158 21.2766 2.46105 20.9872L20.9877 2.46056C21.2771 2.17109 21.5666 2.17109 21.8561 2.46056L27.718 8.3225C28.0075 8.61197 28.0799 8.82908 27.718 9.19093L21.4942 15.4147C21.2048 15.7042 21.2048 15.9937 21.4942 16.2831C23.5693 18.4065 26.9856 21.9022 31.4451 23.9181C36.728 26.3063 40.4189 23.2668 41.5406 22.1451L40.5274 21.1319C40.5068 21.1525 40.4841 21.1756 40.4592 21.2009C39.7396 21.9307 37.2025 24.504 32.0964 22.6155C29.4172 21.6245 25.0886 17.7064 23.0864 15.7042L28.6588 10.1317C29.672 9.11856 29.672 8.25013 28.6588 7.23695L22.8693 1.44739C21.8561 0.434217 20.9877 0.434217 19.9745 1.44739L1.44788 19.974C0.434709 20.9872 0.434708 21.8556 1.44788 22.8688L7.23744 28.6583C8.25062 29.6715 9.11905 29.6715 10.1322 28.6583L15.7771 23.0135C17.7793 25.0157 21.6974 29.3443 22.6883 32.0235C24.5771 37.1301 21.9354 39.7349 21.2014 40.4586C21.176 40.4836 21.1529 40.5064 21.1324 40.5269Z",
    fill: "url(#paint6_linear_12_42145)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2445 15.8489C34.955 15.5594 34.6655 15.5594 34.376 15.8489L29.093 21.1319L28.0799 20.1187L33.3628 14.8358C34.376 13.8226 35.2445 13.8226 36.2576 14.8358L42.0472 20.6253C43.0604 21.6385 43.0604 22.5069 42.0472 23.5201L23.5206 42.0467C22.5074 43.0599 21.639 43.0599 20.6258 42.0467L14.8362 36.2571C13.8231 35.244 13.8231 34.3755 14.8362 33.3624L20.1916 28.007L21.2048 29.0202L15.8494 34.3755C15.5599 34.665 15.5599 34.9545 15.8494 35.244L21.7114 41.1059C22.0008 41.3954 22.2179 41.4677 22.5798 41.1059L41.1064 22.5793C41.4682 22.2174 41.3959 22.0003 41.1064 21.7109L35.2445 15.8489Z",
    fill: "url(#paint7_linear_12_42145)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_42145",
    x1: 68.3564,
    y1: 4.52277,
    x2: 99.2766,
    y2: 26.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_42145",
    x1: 10.7112,
    y1: 10.7107,
    x2: 32.7839,
    y2: 32.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_42145",
    x1: 10.7112,
    y1: 10.7107,
    x2: 32.7839,
    y2: 32.7834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.91738d5af3df433bd9fcd130d0ed4c9d.svg";
export { ForwardRef as ReactComponent };